









import { Component, Vue } from 'vue-property-decorator'
import { State, Action, Getter } from 'vuex-class'

import {
    CurrentStepTitle,
    SFSelect,
    SFRadio,
    SFInput,
    BoxHeading,
    ProgressFooter,
    SFGrid,
    SFLoader
    } from '@/components'

const namespace = 'reports';

@Component({
    components: {
        CurrentStepTitle,
        SFSelect,
        SFRadio,
        SFInput,
        BoxHeading,
        ProgressFooter,
        SFGrid,
        SFLoader
    }
})

export default class List extends Vue {
    @Action('fetchReports', {  namespace }) fetchReports: any;
    @Getter('getReports', {  namespace }) getReports: any;


    constructor() {
        super();

        const config = {
            columns: [
                {
                    name: 'Company Name',
                    className: '.grid__item.width-2of12',
                    value: 'company_name',
                    type: 'string'
                }
            ]
        }
    }

    isLoading: boolean = true;
    reports = this.getReports;
    currentSort = 'company_name';
    currentSortDir = 'asc';
    
    mounted(): void {
        this.fetchReports().then(() => { this.isLoading = false });
    }
 };
